module.exports = __webpack_public_path__ + "img/calligraphy-work-icon5.a7c38745.jpg";